export function state (storeProduct) {
  storeProduct.state.instantSearch = {}
  return storeProduct.state
}
